import { useContext } from 'react';

import { PageLockContext } from 'contexts/page-lock/PageLockContext';

export const usePageLock = () => useContext(PageLockContext);
